var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 41C31.8218 41 41 31.8218 41 20.5C41 9.17816 31.8218 0 20.5 0C9.17816 0 0 9.17816 0 20.5C0 31.8218 9.17816 41 20.5 41Z",
    fill: "#E0D1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 24.7002C10.533 25.1202 10.287 26.0302 10.701 26.7502C11.115 27.4702 12.033 27.7103 12.75 27.3003L11.25 24.7002ZM30.769 16.3902C30.984 15.5902 30.509 14.7703 29.709 14.5503L16.669 11.0603C15.869 10.8403 15.046 11.3202 14.832 12.1202C14.617 12.9202 15.092 13.7402 15.892 13.9502L27.483 17.0603L24.378 28.6502C24.163 29.4502 24.638 30.2702 25.438 30.4902C26.238 30.7002 27.061 30.2303 27.275 29.4303L30.769 16.3902ZM12.75 27.3003L30.071 17.3003L28.571 14.7002L11.25 24.7002L12.75 27.3003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowd);
export default __webpack_public_path__ + "static/media/arrowd.b6102d438ec527bcfdb3c9446d8c62e3.svg";
export { ForwardRef as ReactComponent };